import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import './termsOfService.css'
import HeaderImage from '../../../components/headerImage/HeaderImage';
import BreadcrumbsCustomized from '../../../components/breadcrumbsCustomized/BreadcrumbsCustomized';
import Context from '../../../contexts/Context';
import SectionContactUs from '../../../components/sectionContactUs/SectionContactUs';
import Section from '../../../components/section/Section';
import ButtonAction from '../../../components/buttonAction/ButtonAction';
import { clone } from '../../../services/serviceslocal';

export default function TermsOfService() {

    const {siteContents} = useContext (Context)

    const {data} = siteContents.find(item => item.id === "terms")
    const termsAndConditions = data.find(item => item.id === "terms-of-service").data[0]
    const {data: dataContacUs} = siteContents.find(item => item.id === "contact-us")
    const contactForCompany = clone(dataContacUs.find(item => item.id === "contactForCompany"))
    contactForCompany.backgroundColor = "Gray"

    return (
        <Box className=" flex col center w100 minh100">
            <BreadcrumbsCustomized title={termsAndConditions.title}/>
            <HeaderImage
                animate
                fixed
                image={termsAndConditions.media}                
            >
                <Typography variant="h2" component="h1" className="tbold tcenter">
                    {termsAndConditions.title}
                </Typography>
            </HeaderImage>

            <Section>
                {termsAndConditions.button.active &&
                    <Box sx={{m:"auto", mb:3}}>
                        <ButtonAction variant="text" size="large" sx={{mt:2, borderRadius:"50px"}} action={termsAndConditions.button.action}>
                            {termsAndConditions.button.title}
                        </ButtonAction>
                    </Box>
                }
                <Typography className="sectionOnlytext_body section_text tj" color="dark"  dangerouslySetInnerHTML={ {__html: termsAndConditions.body}}/>
            </Section>

            <SectionContactUs data={contactForCompany}/>
        </Box>
    );
}
